export class JobCatalogue {
    id: string;
    Category: string;
    Description: string;
    Overview: string;
    Requirements: string;
    Responsibilities: string;
    Role: string;
}
